import { createBuilderModule } from '../../builder';
import { Breadcrumbs } from './Breadcrumbs';

export default createBuilderModule(Breadcrumbs, {
  name: 'Breadcrumbs',
  image:
    'https://globalsymbols.com/uploads/production/image/imagefile/3364/13_3364_30369cc3-b4cd-42ce-9385-2aa9f7bf489c.svg',
  inputs: [
    {
      name: 'currentPage',
      type: 'string',
    },
    {
      name: 'size',
      type: 'string',
      enum: ['small', 'large'],
    },
    {
      name: 'links',
      type: 'list',
      subFields: [
        { name: 'text', type: 'string', required: true },
        { name: 'href', type: 'string', required: true },
      ],
    },
  ],
});
